import { Inventory, InventoryApi, MpxResponseBaseSingle } from '@cibo/core'
import { UseQueryOptions, useQuery, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ascend, assocPath, prop } from 'ramda'
import { INVENTORIES_QUERY_KEYS } from './queryKeys'

export const useInventory = (
  inventoryId?: string,
  options?: Omit<
    UseQueryOptions<MpxResponseBaseSingle<Inventory>, unknown, unknown, unknown[]>,
    'queryKey' | 'queryFn'
  >
) => {
  const queryClient = useQueryClient()
  return useQuery<
    MpxResponseBaseSingle<Inventory>,
    AxiosError,
    MpxResponseBaseSingle<Inventory>,
    any
  >({
    queryKey: [INVENTORIES_QUERY_KEYS.INVENTORIES, inventoryId],
    queryFn: async () => {
      if (!inventoryId) {
        return
      }
      const inventory = await InventoryApi.getInventory(inventoryId)
      inventory.data.item.boundaries.forEach(boundary => {
        queryClient.setQueryData(
          [INVENTORIES_QUERY_KEYS.BOUNDARIES, inventoryId, boundary.boundaryId],
          { item: boundary }
        )
      })

      return assocPath(
        ['item', 'boundaries'],
        inventory.data.item.boundaries.sort(ascend(prop('createdDate')))
      )(inventory.data)
    },
    ...options,
  })
}
